<template>
  <div class="quote-modal" @click.self="close">
    <div class="quote-box">
      <button class="close-btn" @click="close">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <h2 class="quote-title">Request a Quote</h2>
      <p class="quote-subtitle">
        Call <a href="tel:7605673777">760-567-3777</a> or fill out the form below.
      </p>

      <form class="quote-form" @submit.prevent>
        <div class="form-group">
          <label>Name</label>
          <input type="text" placeholder="Your name" />
        </div>
        <div class="form-group">
          <label>Phone</label>
          <input type="tel" placeholder="Your phone number" />
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email" placeholder="Your email" />
        </div>
        <div class="form-group">
          <label>Message</label>
          <textarea placeholder="Tell us about your needs" rows="3"></textarea>
        </div>
        <button type="submit" class="submit-btn">Submit Request</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit("showQuote", false);
    }
  }
};
</script>

<style scoped>
.quote-modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  padding: 1rem;
}

.quote-box {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 2.5rem;
  width: 100%;
  max-width: 420px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  padding: 4px;
  transition: color 0.2s;
}

.close-btn:hover {
  color: var(--color-text);
}

.quote-title {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.quote-subtitle {
  font-size: 0.9rem;
  color: var(--color-text-muted);
  margin-bottom: 1.5rem;
}

.quote-subtitle a {
  color: var(--color-fire);
  font-weight: 600;
  text-decoration: none;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-text-muted);
  margin-bottom: 0.35rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.65rem 0.9rem;
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  color: var(--color-text);
  font-family: var(--font-body);
  font-size: 0.875rem;
  transition: border-color 0.2s;
  resize: vertical;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--color-fire);
}

.submit-btn {
  width: 100%;
  padding: 0.75rem;
  background: var(--color-fire);
  color: white;
  border: none;
  border-radius: 4px;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.5rem;
}

.submit-btn:hover {
  background: var(--color-fire-light);
}
</style>
